import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import api from '../../http';
import { authStorage } from '../../../auth';
import { User } from '@practium/shared';
import { getApiErrorMessage, toApiError, getApiUrl } from '../utils';

interface ApiResponseExchangeHandoff {
	csrfToken: string;
	accessToken: string;
	rememberMe: boolean;
}

export const useExchangeHandoff = () => {
	return useMutation({
		mutationFn: async (code: string) => {
			const response = await api
				.post<ApiResponseExchangeHandoff>('/auth/handoff/exchange', { code })
				.catch((error) => {
					throw toApiError(error, 'Não foi possível concluir o login');
				});

			const cleanToken = response.data.accessToken.replace(/^bearer\s+/i, '');
			const { csrfToken, rememberMe } = response.data;

			const { data: user } = await axios
				.get<User>(`${getApiUrl()}user/get`, {
					headers: { Authorization: `bearer ${cleanToken}` },
				})
				.catch((error) => {
					throw toApiError(error, 'Não foi possível concluir o login');
				});

			return { user, token: cleanToken, csrfToken, rememberMe };
		},
		onSuccess: ({ user, token, csrfToken, rememberMe }) => {
			authStorage.saveSession(user, token, rememberMe);
			authStorage.saveCsrf(csrfToken);
		},
		onError: (error) => {
			console.error('Erro ao concluir a transferência de sessão:', getApiErrorMessage(error, 'Não foi possível concluir o login'));
		},
	});
};
